import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, catchError, EMPTY, filter, switchMap, take, throwError } from 'rxjs';
import { StoreService } from '../services/store.service';
import { LoginClientService } from '../services/login-client.service';
import { isEmpty } from '../helpers/string-helper';

let isRefreshing = false;
let refreshTokenSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
/**
 * HttpUnauthorizedRequestInterceptor implements HttpInterceptor.
 * Redirect to login page when accessing not authorized request
 */
export const httpUnauthorizedRequestInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  let storeService = inject(StoreService);
  let loginClientService = inject(LoginClientService);
  if (req.url.includes('/services/auth/refresh') || req.url.includes('/auth/refresh')) {
    return next(req);
  }

  return next(req).pipe(
    catchError((response: HttpResponse<any>) => {
      if (response instanceof HttpErrorResponse && response.status === 401) {
        if (!isRefreshing) {
          isRefreshing = true;
          refreshTokenSubject.next(null);

          return loginClientService.refreshToken().pipe(
            switchMap((response: any) => {
              isRefreshing = false;
              refreshTokenSubject.next(response.accessToken);
              if (response.accessToken) {
                req = req.clone({
                  setHeaders: {
                    Authorization: `Bearer ${response.accessToken}`
                  }
                });
              }
              return next(req);
            }),
            catchError((error) => {
              isRefreshing = false;
              refreshTokenSubject.next(null);
              storeService.logout();
              storeService.clear();
              router.navigate(['/login']);
              localStorage.removeItem('isLogged');
              localStorage.removeItem('isContractSelected');
              localStorage.removeItem('contracts');
              localStorage.removeItem('authorities');
              return throwError(() => error);
            })
          );
        } else {
          return refreshTokenSubject.pipe(
            filter(token => token !== null),
            take(1),
            switchMap(token =>
              {
                if (token) {
                  req = req.clone({
                    setHeaders: {
                      Authorization: `Bearer ${token}`
                    }
                  });
                }
                return next(req);
              }
            ));
        }
      }
      /*if (response && (response.status === 401 || response.status === 403)) {
        loginClientService
          .getUser()
          .pipe(take(1))
          .subscribe((loginResponse) => {
            if (loginResponse !== null &&  loginResponse.utilisateur !== null && !isEmpty(loginResponse.utilisateur.id)) {
              router.navigate(['/home']);
            } else {
              storeService.logout();
              storeService.clear();
              router.navigate(['/login']);
              localStorage.removeItem('isLogged');
              localStorage.removeItem('isContractSelected');
              localStorage.removeItem('contracts');
              localStorage.removeItem('authorities');
            }
          });
        return EMPTY;
      }*/
      return throwError(() => response);
    }),
  );
};
